module.exports = __webpack_public_path__ + "static/media/stonefruit.d9b24a3c.webp";